import React from "react";
import logo from "../../assets/img/logo.png";
import paidImg from "../../assets/img/paid.png";
import "./AdmissionChallanPdfStyles.css";

const styles = {
  challanWrapper: {
    width: "33%",
    display: "inline-block",
    padding: "2px 5px",
    borderRight: "1px dashed",
    color: "#000",
  },
};

function AdmissionChallanHtml({ challanData }) {
  const copyTypes = ["Bank Copy", "School Copy", "Student Copy"];

  // Combine all fee details from all vouchers into a single list
  const combinedFeeDetails = challanData.flatMap(
    (voucher) => voucher.admissionVoucherDetailDto
  );

  // Calculate the total amount
  const totalAmount = combinedFeeDetails.reduce(
    (total, fee) => total + (fee.netAmount || 0),
    0
  );

  return (
    <>
      {copyTypes.map((copyType, index) => (
        <div style={styles.challanWrapper} key={index}>
          <table border="0">
            <tbody>
              <tr>
                <td>
                  <img
                    src={logo}
                    alt="logo"
                    style={{
                      width: "auto",
                      height: "18px",
                      display: "inline-block",
                      margin: "0",
                    }}
                  />
                </td>
                <td className="text-right">
                  <strong>{copyType}</strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  Challan #:
                  <strong
                    style={{
                      display: "inline-block",
                      padding: "0 3px",
                    }}
                  >
                    {challanData[0].voucherNo}{" "}
                    {/* Assuming all vouchers have the same voucherNo */}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  Center/Campus Name:
                  <strong
                    style={{
                      display: "inline-block",
                      padding: "0 3px",
                    }}
                  >
                    {challanData[0].centerName}{" "}
                    {/* Assuming all vouchers have the same centerName */}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  Student Name:
                  <strong
                    style={{
                      display: "inline-block",
                      padding: "0 3px",
                    }}
                  >
                    {challanData[0].studentName}{" "}
                    {/* Assuming all vouchers have the same studentName */}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  Class:
                  <strong
                    style={{
                      display: "inline-block",
                      padding: "0 3px",
                    }}
                  >
                    {challanData[0].className}{" "}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  Registration #:
                  <strong
                    style={{
                      display: "inline-block",
                      padding: "0 3px",
                    }}
                  >
                    {challanData[0].registrationNo}{" "}
                  </strong>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <table
                    style={{
                      marginTop: "10px",
                      border: "1px solid",
                    }}
                  >
                    <tbody>
                      <tr>
                        <th colSpan="5" className="text-center">
                          <strong>FEE DETAILS</strong>
                        </th>
                      </tr>
                      <tr>
                        <th>Fee Type</th>
                        <th>Amount</th>
                        <th>Concession Amount</th>
                        <th>VAT</th>
                        <th className="text-right">Net Amount</th>
                      </tr>
                      {combinedFeeDetails.map((fee, feeIndex) => (
                        <tr key={feeIndex}>
                          <td>{fee.feeTypeName}</td>
                          <td>{fee.amount.toLocaleString()}</td>
                          <td>{fee.concession.toLocaleString()}</td>
                          <td>{fee.vat.toLocaleString()}</td>
                          <td className="text-right">
                            {fee.netAmount.toLocaleString()}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <th colSpan="4">Total</th>
                        <th className="text-right">
                          {totalAmount.toLocaleString()}
                        </th>
                      </tr>
                      <tr>
                        <td colSpan="4">Paid / Adjusted</td>
                        <td className="text-right">0</td>
                      </tr>
                      <tr>
                        <th colSpan="4">Total Payment (PKR)</th>
                        <th className="text-right">
                          {totalAmount.toLocaleString()}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <table
                    style={{
                      marginTop: "10px",
                      border: "1px solid",
                    }}
                  >
                    <tbody>
                      <tr>
                        <th colSpan="2" className="text-center">
                          <strong>BANKING DETAILS</strong>
                        </th>
                      </tr>
                      <tr>
                        <td>Account # Collection:</td>
                        <td>0074152356534</td>
                      </tr>
                      <tr>
                        <td>Branch Code:</td>
                        <td>0074</td>
                      </tr>
                      <tr>
                        <td>Account Name:</td>
                        <td>Account Name Here</td>
                      </tr>
                      <tr>
                        <td>PV (Roll #):</td>
                        <td>208383</td>
                      </tr>
                      <tr>
                        <td>Buyer (Challan #):</td>
                        <td>754114</td>
                      </tr>
                      <tr>
                        <td>Due Date:</td>
                        <td>05-12-2024</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td colSpan="3" className="text-center">
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        color: "#d1d1d1",
                        fontSize: "16px",
                        marginTop: "10px",
                      }}
                    >
                      <strong>CASH ONLY</strong>
                    </div>
                    <div
                      style={{
                        color: "#d1d1d1",
                        border: "1px solid #d1d1d1",
                        padding: "5px 10px",
                        width: "120px",
                        margin: "auto",
                      }}
                    >
                      <strong>Bank Stamp Here</strong>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
}

export default AdmissionChallanHtml;
